export function getPrintDocumentError(printOptionId: string): string {
    let name = 'Das Dokument';
    switch (printOptionId) {
        case 'invoice':
            name = 'Die Rechnung';
            break;
        case 'order':
            name = 'Der Lieferschein';
            break;
        case 'weighing_slip':
            name = 'Der Wiegeschein';
            break;
        case 'consolidated_weighing_slip':
            name = 'Der Sammelwiegeschein';
            break;
    }

    return `${name} konnte nicht erzeugt werden!`;
}
